'use client';

import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    // Backend integration point: POST /api/newsletter/subscribe
    setSubmitted(true);
    toast.success('You\'re subscribed! Welcome to the WebMint newsletter.');
  };

  return (
    <section id="newsletter" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/10 via-accent/5 to-secondary/10" />
      <div className="absolute inset-0 grid-dot-pattern opacity-30" />
      <div className="relative max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 rounded-2xl bg-primary/20 border border-primary/30 flex items-center justify-center mx-auto mb-6">
            <Mail size={24} className="text-primary" />
          </div>
          <h2 className="font-display font-bold text-2xl md:text-3xl text-foreground mb-3">
            Stay Ahead of the Digital Curve
          </h2>
          <p className="text-muted-foreground text-sm mb-8">
            Bi-weekly insights on web performance, design trends, and agency growth. No spam — unsubscribe anytime.
            <br />
            <span className="text-muted-foreground/60 text-xs">Joined by 4,200+ designers and developers.</span>
          </p>
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@company.com"
                required
                className="flex-1 px-4 py-3 bg-muted/60 border border-border/50 rounded-xl text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary/60 transition-all duration-200"
              />
              <button type="submit" className="btn-primary text-sm px-6 py-3 flex-shrink-0">
                Subscribe <ArrowRight size={14} />
              </button>
            </form>
          ) : (
            <div className="flex items-center justify-center gap-2 text-emerald">
              <CheckCircle2 size={18} />
              <span className="font-display font-semibold text-sm">You&apos;re on the list!</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}